import axios from 'axios';

/**
 * In our form data in segment, we only store the brandId, to pre populate selected brandId, we should fetch the brandName from API
 *
 */
export const fetchBrandNames = async (queryKey) => {
  const [, { appName, retailerId, brandId }] = queryKey;
  try {
    const response = await axios.get(
      `/api/${appName}/GetEntityMetadata?entityType=brand&entityId=${brandId}&retailerId=${retailerId}`
    );

    return { n: response?.data?.brandName, i: response?.data?.brandId };
  } catch {
    console.error(`couldn't fetch brand name for brandId ${brandId}`);
    return `Brand Id: ${brandId}}`;
  }
};
